module.exports = __webpack_public_path__ + "static/media/1_05.8ff1a752.jpg";